import { CategoryResolver } from './core/resolvers/category.resolver';

export const routes: any = [
  {
    path: '',
    loadChildren: () => import(`./features/pages/pages.routes`)
      .then(routes => routes.routes),
    resolve: {
      categories: CategoryResolver
    }
  }
];
